import React from 'react'

export default () => {
  return (
    <div>
        <h2> It seems like this dizziness is most likely the effect of a medication.</h2>
        <p>Many medications list dizziness or lightheadedness as a side effect, including quite a few that are taken over the counter for common ailments. Some of the most common dizziness-causing medications include, but are not limited to:</p>
        
          <ul className="dash">
           <li><strong>Anticonvulsants</strong> [ex: Divalproex (Depakote), gabapentin (Neurontin), and pregabalin (Lyrica)]</li>
           <li><strong>Antidepressants</strong> [ex: Fluoxetine (Prozac), sertraline (Zoloft), and trazodone (Desyrel)]</li>
           <li><strong>Blood Pressure Medication</strong> [ex: lisinopril (Zestril), propranolol (Inderal), metoprolol (Lopressor), furosemide (Lasix), amlodipine (Norvasc)]</li>
           <li><strong>Muscle Relaxants</strong> [ex: Cyclobenzaprine (Amrix or Flexeril), metaxalone (Skelaxin), and tizanidine (Zanaflex)]</li>
           <li><strong>Nitroglycerin</strong></li>
           <li><strong>Pain Relievers</strong> [ex: Hydrocodone, ibuprofen (Motrin), Naproxen (Advil)]</li>
           <li><strong>Sleeping Pills</strong> [ex: Diphenhydramine (Benadryl, Unisom, Sominex), temazepam (Restoril), eszopiclone (Lunesta), and zolpidem (Ambien)]</li>
          </ul>
        
        <p>For full information on what medication might be causing your dizziness, check out the literature that came with the medication, or consult with your healthcare provider for some alternatives you may be able to transition to.</p>
        
    </div>
  )
}
